import { formatNumberWithComma } from '../../../../../../utils/format-numbers.utils';
import Label from '../../../../../ui/label';
import { InputByLevelRanking } from '../../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.state';

interface Props {
    isPreview?: boolean;
    inputsByLevelRanking: InputByLevelRanking[]
    selectedCoverageTypeState: string | undefined
}

export default function LevelRanking({ isPreview, inputsByLevelRanking, selectedCoverageTypeState }: Props) {

    const border = isPreview ? '' : 'border'
    return (
        <div className='flex flex-col bg-white overflow-hidden'>
            <div className='p-2 flex items-center justify-between border-b border-[#186cb2]/20 bg-[#186cb2]/10'>
                <div className='space-y-1'>
                    <Label
                        label={selectedCoverageTypeState ?? ""}
                        fontSize="text-xs"
                        fontWeight={`${isPreview ? 'text-xs font-semibold text-gray-800' : 'text-white'}`}
                    />
                    {!isPreview && (
                        <p className="text-xs text-white">
                            Enter the corresponding coverage amount for each designation.
                            You can add multiple rows as needed.
                        </p>
                    )}
                </div>
            </div>
            <div className={`overflow-x-auto bg-white ${isPreview ? 'p-' : 'p-2'}`}>
                <table className={`w-full ${isPreview ? '' : 'border-collapse'}`}>
                    <thead>
                        <tr className="bg-gray-100 text-black">
                            <th className={`${border} font-medium text-xs px-2 py-2 text-left`}>Designation</th>
                            <th className={`${border} font-medium text-xs px-2 py-2 text-left`}>Average Salary</th>
                        </tr>
                    </thead>
                    <tbody>
                        {inputsByLevelRanking.map((input, index) => (
                            <tr key={index}>
                                <td className={`${border} p-2 text-xs`}>{input.label}</td>
                                <td className={`${border} p-2 text-xs`}>{formatNumberWithComma(input.fAmount)}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div> 
    )
}
